// import React, { useEffect, useState } from "react";
// import "./Counselling.css";
// import { useNavigate } from "react-router-dom";
// import { getCounsellor, counsellorsBookedByMe, getUserById } from "../api/api";
// import { environment } from "../../environments/environments";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import {
//   faCalendarCheck,
//   faComment,
//   faStar as faSolidStar,
// } from "@fortawesome/free-solid-svg-icons";
// import { faStar as faRegularStar } from "@fortawesome/free-regular-svg-icons";

// const Counselling = () => {
//   const navigate = useNavigate();
//   const [counsellors, setCounsellors] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [bookings, setBookings] = useState([]);
//   const [currUserallData, setcurrUserallData] = useState(null);

//   useEffect(() => {
//     fetchUserData();
//     fetchCounsellors();
//     checkCounsellorsBookedByMe();
//   }, []);

//   const fetchUserData = async () => {
//     try {
//       const userData = JSON.parse(localStorage.getItem("currentUser"));
//       const userId = userData?.id || userData?._id;
//       const response = await getUserById({ user_id: userId });
//       setcurrUserallData(response);
//     } catch (error) {
//       console.error("Error fetching user data:", error);
//     }
//   };

//   const fetchCounsellors = async () => {
//     try {
//       const response = await getCounsellor();
//       setCounsellors(response.counsellors || []);
//     } catch (error) {
//       console.error("Error fetching counsellors:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const checkCounsellorsBookedByMe = async () => {
//     const userData = JSON.parse(localStorage.getItem("currentUser"));
//     const userId = userData?.id || userData?._id;

//     try {
//       const values = { user_id: userId };
//       const response = await counsellorsBookedByMe(values);
//       setBookings(response.data || []);
//     } catch (error) {
//       console.error("Error fetching bookings:", error);
//     }
//   };

//   const handleOpenWebView = (item) => {
//     const userData = JSON.parse(localStorage.getItem("currentUser"));
//     const userId = userData?.id || userData?._id;
//     const url = `https://backend.connecttovow.com/book-a-slot/${
//       item.id || item._id
//     }/${userId}`;
//     navigate("/Sidebar/ConsultPaymentWebView", { state: { paymentUrl: url } });
//   };

//   const chatConsult = (item) => {
//     navigate("/Sidebar/ChatConsult", { state: { item } });
//   };

//   const formatRole = (role) => {
//     switch (role) {
//       case "match_success_advisor":
//         return "Match Success Advisor";
//       case "connection_curator":
//         return "Connection Curator";
//       case "match_making_consultant":
//         return "Match Making Consultant";
//       case "relationship_success_coach":
//         return "Relationship Success Coach";
//       default:
//         return role?.replace(/_/g, " ");
//     }
//   };

//   const counsellingDisabled =
//     currUserallData?.data?.councelling?.plans?.counselling === "0" ||
//     currUserallData?.data?.councelling === null;

//   if (loading) {
//     return (
//       <div className="loader-container">
//         <div className="spinner"></div>
//       </div>
//     );
//   }

//   return (
//     <div className="counselling-container">
//       <div
//         className={`counselling-scroll-area ${
//           counsellingDisabled ? "blurred" : ""
//         }`}
//       >
//         {counsellors.map((item) => {
//           const imageUrl = `${environment.url}/uploads/counsellors/${item.image}`;
//           const isBooked = bookings.some((b) => b.counsellor_id === item.id);
//           const fullStars = Math.floor(item?.average_rating || 0);
//           const hasHalfStar = (item?.average_rating || 0) - fullStars >= 0.5;

//           return (
//             <div className="card-main-div" key={item.id}>
//               <div className="cardCounselling">
//                 <img src={imageUrl} alt={item.name} className="avatar" />
//                 <div className="details">
//                   <p className="name">{item.name}</p>
//                   <p className="role">{formatRole(item.role)}</p>
//                   {isBooked ? (
//                     <button
//                       className="consult-chat-button"
//                       onClick={() => chatConsult(item)}
//                     >
//                       <FontAwesomeIcon icon={faComment} /> Chat Now
//                     </button>
//                   ) : (
//                     <button
//                       className="book-button"
//                       onClick={() => handleOpenWebView(item)}
//                     >
//                       <FontAwesomeIcon icon={faCalendarCheck} /> Book Now
//                     </button>
//                   )}
//                 </div>
//               </div>
//             </div>
//           );
//         })}
//       </div>

//       {counsellingDisabled && (
//         <div className="counselling-overlay">
//           <p>Your current plan doesn't support counselling access.</p>
//           <button
//             className="upgrade-plan-button"
//             onClick={() =>
//               navigate("/SubscriptionPlans", {
//                 state: { counsellingEnabled: 1 },
//               })
//             }
//           >
//             Upgrade Plan
//           </button>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Counselling;

import React, { useEffect, useState } from "react";
import "./Counselling.css";
import { useNavigate } from "react-router-dom";
import { getCounsellor, counsellorsBookedByMe, getUserById } from "../api/api";
import { environment } from "../../environments/environments";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCalendarCheck,
  faComment,
  faStar as faSolidStar,
} from "@fortawesome/free-solid-svg-icons";
import { faStar as faRegularStar } from "@fortawesome/free-regular-svg-icons";
import { FaStar, FaStarHalfAlt, FaRegStar, FaUserTimes } from "react-icons/fa";

const Counselling = () => {
  const navigate = useNavigate();
  const [counsellors, setCounsellors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [bookings, setBookings] = useState([]);
  const [currUserallData, setcurrUserallData] = useState(null);

  useEffect(() => {
    fetchUserData();
    fetchCounsellors();
    checkCounsellorsBookedByMe();
  }, []);

  const fetchUserData = async () => {
    try {
      const userData = JSON.parse(localStorage.getItem("currentUser"));
      const userId = userData?.id || userData?._id;
      const response = await getUserById({ user_id: userId });
      setcurrUserallData(response);
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  const fetchCounsellors = async () => {
    try {
      const response = await getCounsellor();
      setCounsellors(response.counsellors || []);
    } catch (error) {
      console.error("Error fetching counsellors:", error);
    } finally {
      setLoading(false);
    }
  };

  const checkCounsellorsBookedByMe = async () => {
    const userData = JSON.parse(localStorage.getItem("currentUser"));
    const userId = userData?.id || userData?._id;

    try {
      const values = { user_id: userId };
      const response = await counsellorsBookedByMe(values);
      setBookings(response.data || []);
    } catch (error) {
      console.error("Error fetching bookings:", error);
    }
  };

  const handleOpenWebView = (item) => {
    const userData = JSON.parse(localStorage.getItem("currentUser"));
    const userId = userData?.id || userData?._id;
    const url = `https://backend.connecttovow.com/book-a-slot/${
      item.id || item._id
    }/${userId}`;
    navigate("/Sidebar/ConsultPaymentWebView", { state: { paymentUrl: url } });
  };

  const chatConsult = (item) => {
    navigate("/Sidebar/ChatConsult", { state: { item } });
  };

  const formatRole = (role) => {
    switch (role) {
      case "match_success_advisor":
        return "Match Success Advisor";
      case "connection_curator":
        return "Connection Curator";
      case "match_making_consultant":
        return "Match Making Consultant";
      case "relationship_success_coach":
        return "Relationship Success Coach";
      default:
        return role?.replace(/_/g, " ");
    }
  };

  const counsellingDisabled =
    currUserallData?.data?.councelling?.plans?.counselling === "0" ||
    currUserallData?.data?.councelling === null;

  if (loading) {
    return (
      <div className="loader-container">
        <div className="spinner"></div>
      </div>
    );
  }

  return (
    <div className="counselling-container">
      <div
        className={`counselling-scroll-area ${
          counsellingDisabled ? "blurred" : ""
        }`}
      >
        {counsellors?.length > 0 ? (
          counsellors.map((item) => {
            const imageUrl = `${environment.url}/uploads/counsellors/${item.image}`;
            const isBooked = bookings.some((b) => b.counsellor_id === item.id);
            const fullStars = Math.floor(item?.average_rating || 0);
            const hasHalfStar = (item?.average_rating || 0) - fullStars >= 0.5;

            return (
              <div className="card-main-div" key={item.id}>
                <div className="cardCounselling">
                  <img src={imageUrl} alt={item.name} className="avatar" />
                  <div className="details">
                    <p className="name">{item.name}</p>
                    <p className="role">{formatRole(item.role)}</p>
                    {isBooked ? (
                      <button
                        className="consult-chat-button"
                        onClick={() => chatConsult(item)}
                      >
                        <FontAwesomeIcon icon={faComment} /> Chat Now
                      </button>
                    ) : (
                      <button
                        className="book-button"
                        onClick={() => handleOpenWebView(item)}
                      >
                        <FontAwesomeIcon icon={faCalendarCheck} /> Book Now
                      </button>
                    )}
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <div className="icon-textco">
            <FaUserTimes
              size={60}
              color={environment?.Coral_Red}
              className="iconssco"
            />
            <h3>Currently no Counsellor available</h3>
          </div>
        )}
      </div>

      {counsellingDisabled && (
        <div className="counselling-overlay">
          <p>Your current plan doesn't support counselling access.</p>
          <button
            className="upgrade-plan-button"
            onClick={() =>
              navigate("/SubscriptionPlans", {
                state: { counsellingEnabled: 1 },
              })
            }
          >
            Upgrade Plan
          </button>
        </div>
      )}
    </div>
  );
};

export default Counselling;
